// Module
var code = "<div class=\"widget-content trend-widget-content\"> <wt-line-chart id=\"{{'id'+vm.item.guid}}\" chart-data=\"vm.data\" clicked=\"vm.clicked\" hovered=\"vm.hovered\" ng-class=\"{'logbook-selection': vm.item.isSelectingLogbook}\" options=\"vm.options\" ratio=\"vm.ratio\" series=\"vm.series\" zoom-control=\"vm.item\"> </wt-line-chart> </div>";
// Exports
module.exports = code;